import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { commonCatalogService, employeeService, sharedDirectory } from "api";
import Notification from "../../components/common/notification/notification";
import { tabKeys } from "../../types/enums";

type State = {
  soHopDong: any;
  BankList: any[];
  ApprovePermissionList: any[];
  ApproveStatusList: any[];
  ApprovePersonList: any[];
  BangLuongTotal: number;
  BangLuongList: any[];
  DuyetBangLuongList: any[];
  DuyetBangLuongTotal: number;
  BHXHTotal: number;
  BHXHList: any[];
  TNCNTotal: number;
  TNCNList: any[];
  LamThemTotal: number;
  LamThemList: any[];
  NghiBuTotal: number;
  NghiBuList: any[];
  DimuonTotal: number;
  DimuonList: any[];
  CauHinhLuongTotal: number;
  CauHinhLuongList: any[];
  ChamCongTotal: number;
  ChamCongList: any[];
  NPList: any[];
  CandidateDirectoryTotal: number;
  CandidateDirectoryList: any[];
  RecruimentTotal: number;
  RecruimentList: any[];
  TraningList: any[];
  TraningTotal: number;
  SWMTotal: number;
  SWMList: any[];
  SGList: any[];
  LHDList: any[];
  LCVList: any[];
  tonGiaoList: any[];
  employeeData: any;
  employee: any;
  cckm:any;
  giayPhepList: any[];
  hopdongTotal: number;
  phongBanList: any[];
  chucVuList: any[];
  quocTichList: any[];
  danTocList: any[];
  hopdongList: any[];
  employeesTotal: number;
  employeesList: any[];
  idEmp: String;
  idKM:string;
  status: boolean;
  edit: boolean;
  type: any;
  activeTabAllocation: any;
  phamViHD: any[];
  noiCap: any[];
  detailDoc: any;
  idDoc: any;
  kyLuat: any[];
  employeeMode: string;
  cckmMode:string;
  wordAddress: any[];
  maDK: any[];
  listLSCT: any[];
  listCa:any[],
  PhanCaTotal: number;
  PhanCaList: any[];
  CauHinhCa:any[],
};

const initialState: State = {
  CauHinhCa:[],
  PhanCaTotal: null,
  PhanCaList: [],
  listCa:[],
  maDK:[],
  wordAddress: [],
  ApprovePermissionList: [],
  ApproveStatusList: [],
  ApprovePersonList: [],
  kyLuat: [],
  noiCap: [],
  phamViHD: [],
  soHopDong: null,
  BankList: [],
  BangLuongTotal: 0,
  BangLuongList: [],
  DuyetBangLuongList: [],
  DuyetBangLuongTotal: 0,
  BHXHTotal: 0,
  BHXHList: [],
  TNCNTotal: 0,
  TNCNList: [],
  LamThemTotal: 0,
  LamThemList: [],
  NghiBuTotal: 0,
  NghiBuList: [],
  DimuonTotal: 0,
  DimuonList: [],
  CauHinhLuongTotal: null,
  CauHinhLuongList: [],
  ChamCongTotal: null,
  ChamCongList: [],
  NPList: [],
  CandidateDirectoryTotal: 0,
  CandidateDirectoryList: [],
  RecruimentTotal: 0,
  RecruimentList: [],
  TraningList: [],
  TraningTotal: 0,
  SWMTotal: 0,
  SWMList: [],
  SGList: [],
  LHDList: [],
  LCVList: [],
  employee: null,
  cckm:null,
  idEmp: null,
  idKM:null,
  employeesTotal: 0,
  hopdongTotal: 0,
  employeesList: [],
  hopdongList: null,
  quocTichList: [],
  danTocList: [],
  chucVuList: [],
  tonGiaoList: [],
  phongBanList: [],
  giayPhepList: [],
  status: false,
  edit: false,
  employeeData: null,
  type: null,
  activeTabAllocation: tabKeys.CATALOG_EMPLOYEE.TAB_POSITION,
  detailDoc: null,
  idDoc: null,
  employeeMode: "",
  cckmMode:"",
  listLSCT: [],
};

export const slice = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    setListEmployees: (state = initialState, action: PayloadAction<any>) => {
      state.employeesList = action.payload.employeesData;
      state.employeesTotal = action.payload.employeesDataTotal;
    },
    setListStandardWorkMonth: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.SWMList = action.payload.SWMData;
      state.SWMTotal = action.payload.SWMDataTotal;
    },
    setListTraning: (state = initialState, action: PayloadAction<any>) => {
      state.TraningList = action.payload.TraningData;
      state.TraningTotal = action.payload.TraningDataTotal;
    },
    setListRecruiment: (state = initialState, action: PayloadAction<any>) => {
      state.RecruimentList = action.payload.RecruimentData;
      state.RecruimentTotal = action.payload.RecruimentDataTotal;
    },
    setListCandidateDirectory: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.CandidateDirectoryList = action.payload.CandidateDirectoryData;
      state.CandidateDirectoryTotal =
        action.payload.CandidateDirectoryDataTotal;
    },
    setListPhanCa: (state = initialState, action: PayloadAction<any>) => {
      state.PhanCaList = action.payload.PhanCaData;
      state.PhanCaTotal = action.payload.PhanCaDataTotal;
    },
    setListChamCong: (state = initialState, action: PayloadAction<any>) => {
      state.ChamCongList = action.payload.ChamCongData;
      state.ChamCongTotal = action.payload.ChamCongDataTotal;
    },
    setListCauHinhLuong: (state = initialState, action: PayloadAction<any>) => {
      state.CauHinhLuongList = action.payload.CauHinhLuongData;
      state.CauHinhLuongTotal = action.payload.CauHinhLuongDataTotal;
    },
    setListDimuon: (state = initialState, action: PayloadAction<any>) => {
      state.DimuonList = action.payload.DimuonData;
      state.DimuonTotal = action.payload.DimuonDataTotal;
    },
    setListNghiBu: (state = initialState, action: PayloadAction<any>) => {
      state.NghiBuList = action.payload.NghiBuData;
      state.NghiBuTotal = action.payload.NghiBuDataTotal;
    },
    setListLamThem: (state = initialState, action: PayloadAction<any>) => {
      state.LamThemList = action.payload.LamThemData;
      state.LamThemTotal = action.payload.LamThemDataTotal;
    },
    setListBank: (state = initialState, action: PayloadAction<any>) => {
      state.BankList = action.payload.BankData;
    },
    setListApprovePermission: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.ApprovePermissionList = action.payload.ApprovePermissionList;
    },
    setListApproveStatus: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.ApproveStatusList = action.payload.ApproveStatusList;
    },
    setListApprovePerson: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.ApprovePersonList = action.payload.ApprovePersonList;
    },
    setListTNCN: (state = initialState, action: PayloadAction<any>) => {
      state.TNCNList = action.payload.TNCNData;
      state.TNCNTotal = action.payload.TNCNDataTotal;
    },
    setListBHXH: (state = initialState, action: PayloadAction<any>) => {
      state.BHXHList = action.payload.BHXHData;
      state.BHXHTotal = action.payload.BHXHDataTotal;
    },
    setListBangLuong: (state = initialState, action: PayloadAction<any>) => {
      state.BangLuongList = action.payload.BangLuongData;
      state.BangLuongTotal = action.payload.BangLuongDataTotal;
    },
    setListDuyetBangLuong: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.DuyetBangLuongList = action.payload.DuyetBangLuongList;
      state.DuyetBangLuongTotal = action.payload.DuyetBangLuongTotal;
    },
    setEmployee: (state = initialState, action: PayloadAction<any>) => {
      state.employee = action.payload;
    },
    setKM: (state = initialState, action: PayloadAction<any>) => {
      state.cckm = action.payload;
    },
    setDataEmployees: (state = initialState, action: PayloadAction<any>) => {
      state.employeeData = action.payload;
    },
    setListHopDong: (state = initialState, action: PayloadAction<any>) => {
      state.hopdongList = action.payload.listHopdong;
    },
    setListGiayPhep: (state = initialState, action: PayloadAction<any>) => {
      state.giayPhepList = action.payload.listGiayPhep;
    },
    setListCauHinh: (state = initialState, action: PayloadAction<any>) => {
      state.CauHinhCa = action.payload.CauHinhCa;
    },
    setListLSCT: (state = initialState, action: PayloadAction<any>) => {
      state.listLSCT = action.payload.listLSCT;
    },
    setQuocTich: (state = initialState, action: PayloadAction<any>) => {
      state.quocTichList = action.payload.quocTichData;
    },
    setDanToc: (state = initialState, action: PayloadAction<any>) => {
      state.danTocList = action.payload.danTocData;
    },
    setTonGiao: (state = initialState, action: PayloadAction<any>) => {
      state.tonGiaoList = action.payload.tonGiaoData;
    },
    setListChucVu: (state = initialState, action: PayloadAction<any>) => {
      state.chucVuList = action.payload.chucVuData;
    },
    setListSG: (state = initialState, action: PayloadAction<any>) => {
      state.SGList = action.payload.SGData;
    },
    setListLHD: (state = initialState, action: PayloadAction<any>) => {
      state.LHDList = action.payload.LHDData;
    },
    setListWord: (state = initialState, action: PayloadAction<any>) => {
      state.wordAddress = action.payload.wordAddress;
    },
    setListKL: (state = initialState, action: PayloadAction<any>) => {
      state.kyLuat = action.payload.kyLuat;
    },
    setListMDK: (state = initialState, action: PayloadAction<any>) => {
      state.maDK = action.payload.maDK;
    },
    setListCa: (state = initialState, action: PayloadAction<any>) => {
      state.listCa = action.payload.listCa;
    },
    setListNP: (state = initialState, action: PayloadAction<any>) => {
      state.NPList = action.payload.NPData;
    },
    setListLCV: (state = initialState, action: PayloadAction<any>) => {
      state.LCVList = action.payload.LCVData;
    },
    setListPhongBan: (state = initialState, action: PayloadAction<any>) => {
      state.phongBanList = action.payload.phongBanData;
    },
    setIdEmployee: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, idEmp: action.payload };
    },
    setIdKM: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, idKM: action.payload };
    },
    setAdd: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, status: action.payload };
    },
    setType: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, type: action.payload };
    },
    setEdit: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, edit: action.payload };
    },
    setPhamVi: (state = initialState, action: PayloadAction<any>) => {
      state.phamViHD = action.payload.phamVi;
    },
    setNoiCap: (state = initialState, action: PayloadAction<any>) => {
      state.noiCap = action.payload.noicap;
    },
    clearEmployee: (state = initialState, action: PayloadAction<any>) => {
      state.employee = null;
    },
    clearCckm: (state = initialState, action: PayloadAction<any>) => {
      state.cckm = null;
    },
    setActiveTabAllocation: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return { ...state, activeTabAllocation: action.payload };
    },
    setSoHopDong: (state = initialState, action: PayloadAction<any>) => {
      state.soHopDong = action.payload;
    },
    setDetailDoc: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, detailDoc: action.payload };
    },
    setIdDoc: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, idDoc: action.payload };
    },
    setEmployeeMode: (state = initialState, action: PayloadAction<any>) => {
      console.log(action);
      return { ...state, employeeMode: action.payload };
    },
    setCCKM: (state = initialState, action: PayloadAction<any>) => {
      console.log(action);
      return { ...state, cckmMode: action.payload };
    },
  },
});

export const {
  setListCauHinh,
  setListPhanCa,
  setListCa,
  setListMDK,
  setListWord,
  setListKL,
  setNoiCap,
  setPhamVi,
  setActiveTabAllocation,
  setListChucVu,
  setListEmployees,
  setListHopDong,
  setQuocTich,
  setDanToc,
  setListPhongBan,
  setIdEmployee,
  setIdKM,
  setListGiayPhep,
  setEmployee,
  setKM,
  setAdd,
  setDataEmployees,
  setEdit,
  setTonGiao,
  setType,
  clearEmployee,
  clearCckm,
  setListLHD,
  setListLCV,
  setListSG,
  setListStandardWorkMonth,
  setListTraning,
  setListRecruiment,
  setListCandidateDirectory,
  setListNP,
  setListChamCong,
  setListCauHinhLuong,
  setListDimuon,
  setListNghiBu,
  setListLamThem,
  setListTNCN,
  setListBHXH,
  setListBangLuong,
  setListBank,
  setSoHopDong,
  setDetailDoc,
  setIdDoc,
  setEmployeeMode,
  setCCKM,
  setListApprovePermission,
  setListApproveStatus,
  setListDuyetBangLuong,
  setListApprovePerson,
  setListLSCT,
} = slice.actions;
export const getDetailDoc = (id) => {
  return async (dispatch) => {
    try {
      const detailDoc = await employeeService.getDetailDoc(id);
      dispatch(setDetailDoc(detailDoc));
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy thông tin văn bản");
    }
  };
};
export const getListCauHinh = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getShiftWorkSetting(params);
      const CauHinhCa = response;
     //  console.log("reponse",CauHinhCa);

      dispatch(
        setListCauHinh({
          CauHinhCa,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách cấu hình ca"
      );
    }
  };
};
export const getWord = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getListAddress(params);
      const wordAddress = response;
      // console.log("reponse",wordAddress);

      dispatch(
        setListWord({
          wordAddress,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh mục địa chỉ làm việc"
      );
    }
  };
};
export const getListCa = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getListShiftWorkSetting(params);
      const listCa = response;
       // console.log("reponse",listCa);

      dispatch(
        setListCa({
          listCa,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy ký hiệu chấm công"
      );
    }
  };
};
export const getListMDK = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getResgister(params);
      const maDK = response;
        //console.log("reponse",maDK);

      dispatch(
        setListMDK({
          maDK,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy thông tin mã đăng ký nghỉ phép"
      );
    }
  };
};
export const getKyLuat = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getDisciplinedemployees(params);
      const kyLuat = response.data;
      //  console.log("reponse",kyLuat);

      dispatch(
        setListKL({
          kyLuat,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách nhân viên kỷ luật"
      );
    }
  };
};
export const getNoiCap = () => {
  return async (dispatch) => {
    try {
      const listNoicap = await employeeService.getNoiCap();
      dispatch(
        setNoiCap({
          noicap: listNoicap,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên");
    }
  };
};
export const getPhamVi = (params) => {
  return async (dispatch) => {
    try {
      const listHopDong = await employeeService.getPhamVi(params);

      dispatch(
        setPhamVi({
          phamVi: listHopDong,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên");
    }
  };
};
export const searchEmployeeAPI = (params) => {
  return async (dispatch) => {
    try {
      const listEmployeeData = await employeeService.searchEmployee(params);
      dispatch(
        setListEmployees({
          employeesData: listEmployeeData.items,
          employeesDataTotal: listEmployeeData.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên");
    }
  };
};
export const exportEmployeeAPI = (params) => {
  return async (dispatch) => {
    try {
      const dataEmployeeData = await employeeService.exportEmployee(params);
      // dispatch(
      //     setDataEmployees({
      //       dataEmployeeData
      //
      //     })
      // );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi xuất excel danh sách nhân viên"
      );
    }
  };
};
export const getHopDongAPI = (id) => {
  return async (dispatch) => {
    try {
      const listHopdong = await employeeService.getContract(id);
      dispatch(
        setListHopDong({
          listHopdong,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách hợp đồng");
    }
  };
};
export const getNation = () => {
  return async (dispatch) => {
    try {
      const response = await sharedDirectory.getListNation();
      const quocTichData = response.data.data;
      dispatch(
        setQuocTich({
          quocTichData,
        })
      );
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục quốc tịch");
    }
  };
};
export const getTonGiao = () => {
  return async (dispatch) => {
    try {
      const response = await commonCatalogService.getListTonGiao();
      const tonGiaoData = response.data;
      dispatch(
        setTonGiao({
          tonGiaoData,
        })
      );
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục dân tộc");
    }
  };
};

export const getDanToc = () => {
  return async (dispatch) => {
    try {
      const response = await sharedDirectory.getListDanToc();
      const danTocData = response.data.data;
      dispatch(
        setDanToc({
          danTocData,
        })
      );
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục dân tộc");
    }
  };
};
export const getChucVuAPI = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getPosition(params);
      const chucVuData = response.data.data;
      dispatch(
        setListChucVu({
          chucVuData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách chức vụ");
    }
  };
};
export const getPhongBanAPI = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getDepartment(params);
      const phongBanData = response.data.data;
      dispatch(
        setListPhongBan({
          phongBanData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách phòng ban");
    }
  };
};
export const getSGAPI = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getWorking(params);
      const SGData = response.data;
      dispatch(
        setListSG({
          SGData,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách số giời làm việc trong tuần"
      );
    }
  };
};
export const getLCVAPI = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getLCV(params);
      const LCVData = response.data.data;
      dispatch(
        setListLCV({
          LCVData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy loại công viêc ");
    }
  };
};
export const getNPAPI = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getNghiPhep(params);
      const NPData = response.data.data;
      dispatch(
        setListNP({
          NPData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy ngày nghỉ phép tháng ");
    }
  };
};
export const getLHDAPI = (params) => {
  return async (dispatch) => {
    try {
      const response = await employeeService.getLHD(params);
      const LHDData = response.data.data;
      dispatch(
        setListLHD({
          LHDData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy loại hợp đồng");
    }
  };
};
export const getGiayPhepAPI = (idEmp) => {
  return async (dispatch) => {
    try {
      const listGiayPhep = await employeeService.getGiayPhep(idEmp);
      dispatch(
        setListGiayPhep({
          listGiayPhep,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách giấy phép");
    }
  };
};
export const getLichSuCongTac = (params) => {
  return async (dispatch) => {
    try {
      const res = await employeeService.getLishSuCongTac(params);
      const listLSCT = res.data.data.items;
      dispatch(
        setListLSCT({
          listLSCT,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách giấy phép");
    }
  };
};
export const searchStandardWorkMonth = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchStandardWorkMonth(params);
      dispatch(
        setListStandardWorkMonth({
          SWMData: data.items,
          SWMDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy công chuẩn trên tháng");
    }
  };
};
export const searchTraning = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchTraning(params);
      dispatch(
        setListTraning({
          TraningData: data.items,
          TraningDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy khóa đào tạo");
    }
  };
};
export const searchRecruiment = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchRecruiment(params);
      dispatch(
        setListRecruiment({
          RecruimentData: data.items,
          RecruimentDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy đợt tuyển dụng ");
    }
  };
};
export const searchCandidateDirectory = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchCandidateDirectory(params);
      dispatch(
        setListCandidateDirectory({
          CandidateDirectoryData: data.items,
          CandidateDirectoryDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục ứng viên ");
    }
  };
};
export const searchPhanCa = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.getShiftList(params).then((res) => {
        try {
          if (res.code === 400) {
            Notification("warning", res.message);
          } else {
            dispatch(
              setListPhanCa({
                PhanCaData: res.data.items,
                PhanCaDataTotal: res.data.total,
              })
            );
          }
        } catch (error) {
          Notification("error", "Đã có lỗi xảy ra khi lấy danh mục phân ca ");
        }
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục phân ca ");
    }
  };
};
export const searchChamCong = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchChamCong(params).then((res) => {
        try {
          if (res.code === 10000) {
            Notification("warning", res.message);
          } else {
            dispatch(
              setListChamCong({
                ChamCongData: res.data.items,
                ChamCongDataTotal: res.data.total,
              })
            );
          }
        } catch (error) {
          Notification("error", "Đã có lỗi xảy ra khi lấy danh mục chấm công ");
        }
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục chấm công ");
    }
  };
};
export const searchCauHinhLuong = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchCauHinhLuong(params);
      dispatch(
        setListCauHinhLuong({
          CauHinhLuongData: data.items,
          CauHinhLuongDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh mục cấu hình lương "
      );
    }
  };
};
export const searchDimuon = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchDimuon(params).then((res) => {
        try {
          if (res.code === 10000) {
            Notification("warning", res.message);
          } else {
            dispatch(
              setListDimuon({
                DimuonData: res.data.items,
                DimuonDataTotal: res.data.total,
              })
            );
          }
        } catch (error) {
          Notification("error", "Đã có lỗi xảy ra khi lấy danh mục đi muộn ");
        }
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục đi muộn ");
    }
  };
};
export const searchNghiBu = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchNghiBu(params).then((res) => {
        try {
          if (res.code === 10000) {
            Notification("warning", res.message);
          } else {
            dispatch(
              setListNghiBu({
                NghiBuData: res.data.items,
                NghiBuDataTotal: res.data.total,
              })
            );
          }
        } catch (error) {
          Notification("error", "Đã có lỗi xảy ra khi lấy danh mục nghỉ bù ");
        }
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục nghỉ bù ");
    }
  };
};
export const searchLamThem = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchLamThem(params).then((res) => {
        try {
          if (res.code === 10000) {
            Notification("warning", res.message);
          } else {
            dispatch(
              setListLamThem({
                LamThemData: res.data.items,
                LamThemDataTotal: res.data.total,
              })
            );
          }
        } catch (error) {
          Notification("error", "Đã có lỗi xảy ra khi lấy danh mục làm thêm ");
        }
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục làm thêm ");
    }
  };
};
export const searchTNCN = (params) => {
  return async (dispatch) => {
    try {
      await employeeService.searchTNCN(params).then((res) => {
        try {
          if (res.code === 10000) {
            Notification("warning", res.message);
          } else {
            dispatch(
              setListTNCN({
                TNCNData: res.data.items,
                TNCNDataTotal: res.data.total,
              })
            );
          }
        } catch (error) {
          Notification(
            "error",
            "Đã có lỗi xảy ra khi lấy danh mục biểu thuế thu nhập cá nhân "
          );
        }
      });
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh mục biểu thuế thu nhập cá nhân "
      );
    }
  };
};
export const searchBHXH = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchBHXH(params);
      dispatch(
        setListBHXH({
          BHXHData: data.items,
          BHXHDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục theo dõi BHXH ");
    }
  };
};
export const searchBangLuong = (params) => {
  return async (dispatch) => {
    try {
      const data = await employeeService.searchBangLuong(params);
      dispatch(
        setListBangLuong({
          BangLuongData: data.items,
          BangLuongDataTotal: data.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy ra bảng lương ");
    }
  };
};

export const searchDuyetBangLuong = (params) => {
  return async (dispatch) => {
    try {
      const res = await employeeService.searchDuyetBangLuong(params);
      if (res.code === 10000) {
        Notification("warning", res.message || "Có lỗi xảy ra");
      } else
        dispatch(
          setListDuyetBangLuong({
            DuyetBangLuongList: res.items,
            DuyetBangLuongTotal: res.total,
          })
        );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy ra duyệt bảng lương");
    }
  };
};
export const getBank = () => {
  return async (dispatch) => {
    try {
      const data = await employeeService.getBank();
      dispatch(
        setListBank({
          BankData: data,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy ra danh sách ngân hàng ");
    }
  };
};

export const getApprovePermissions = (params: {
  page: number;
  limit: number;
}) => {
  return async (dispatch) => {
    try {
      const res = await employeeService.getApprovePermissions(params);
      dispatch(
        setListApprovePermission({
          ApprovePermissionList: res.data.data,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy ra danh sách quyền duyệt"
      );
    }
  };
};

export const getApproveStatus = (params: { page: number; limit: number }) => {
  return async (dispatch) => {
    try {
      const res = await employeeService.getApproveStatus(params);
      dispatch(
        setListApproveStatus({
          ApproveStatusList: res.data.data,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy ra danh sách trạng thái");
    }
  };
};

export const getApprovePersons = (params: { page: number; limit: number }) => {
  return async (dispatch) => {
    try {
      const res = await employeeService.getApprovePersons(params);

      dispatch(
        setListApprovePerson({
          ApprovePersonList: res.data.data,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy ra danh sách trạng thái");
    }
  };
};

export default slice.reducer;
